"use strict";

const LetterResponseModal = function () {
  const formKey = "lid-response";
  var $modal;
  var props;
  var initialFormData;

  var loadDomListeners = function () {
    const $modalContent = $modal.find(".modal-content");

    $modalContent.on("click", ".cancel-button", _closeModalIfConfirmed);
    $modalContent.on("click", ".save-response-button", _saveResponseIfConfirmed);
    $modalContent.on("click", ".preview-button", _onPreviewLetter);
    $modalContent.on("click", ".js-download-project-preview", _onPreviewProject);
    $modalContent.on(
      "2N:FormInput",
      `[name="response"], [name^="receive[bmpMaintenance]"]`,
      _toggleAction,
    );
    $modalContent.on("click", ".download-inspection-report", _downloadInspectionReport);
    $modalContent.on("2N:FormInput", checkEnableSendButton);
    $modalContent.on("click", ".js-edit-project", _onEditProject);
  };

  var _closeModalIfConfirmed = function () {
    if (props.readOnly || Object.keys(Form.getDataFromForm(formKey, false)).length === 0) {
      close();
    } else {
      MessageModal.showConfirmWarningModal(
        null,
        close,
        "Go Back",
        "Close Without Saving",
        CommonModalFunctions.getCloseWithoutSavingPrompt(),
      );
    }
  };

  var _downloadInspectionReport = function () {
    const inspectionId = $(this).data("inspectionId");
    ApiCalls.downloadConstructionInspectionReport(inspectionId, null, "inspection");
  };

  var _saveResponseIfConfirmed = function () {
    const action = getCurrentData().action;
    const returnMessage = "Go Back";
    const okMessage = getActionTypes(action).send ? "Generate" : "Save";
    const confirmMessage =
      `Clicking “${okMessage}” will save the information entered` +
      getResponseResultMessages(action, props.projectsData.length) +
      ` To proceed, click “${okMessage}”. To go back, click “${returnMessage}”.`;

    MessageModal.showConfirmWarningModal(null, _save, returnMessage, okMessage, confirmMessage);
  };

  var getResponseResultMessages = function (action, projectsLength) {
    if (action === "receive") {
      if (projectsLength === 1) {
        return `, indicating this project has completed its operations & maintenance for the year, and remove it from your To Do List.`;
      } else {
        return `, indicating these <strong>${projectsLength}</strong> projects have completed their operations & maintenance for the year, and remove them from your To Do List.`;
      }
    } else if (getActionTypes(action).send) {
      if (projectsLength === 1) {
        const emailsEnabled = Session.notificationEnabled("pdf-letters");
        return ` and generate a PDF O&M letter for this project${getSavePdfText(emailsEnabled)}.`;
      } else {
        const emailsEnabled = Session.notificationEnabled("pdf-letters");
        return ` and generate${emailsEnabled ? ` a .zip file that includes` : ""} <strong>${projectsLength}</strong> O&M PDF letters${getSavePdfText(emailsEnabled)}. If the selected contact information is missing for a project, 2NFORM will attempt to generate the letter using the other contact option.`;
      }
    } else if (action === "unresponsive") {
      if (projectsLength === 1) {
        return `, indicating this project is unresponsive for the year, and remove it from your To Do List.`;
      } else {
        return `, indicating these <strong>${projectsLength}</strong> projects are unresponsive for the year, and remove them from your To Do List.`;
      }
    } else {
      throw new Error(`No confirm message set for action ${action}`);
    }
  };

  var getSavePdfText = function (emailEnabled) {
    if (emailEnabled) {
      return " that will be emailed to you shortly";
    }

    return " that will be available from the project history shortly";
  };

  var checkEnableSendButton = function () {
    const canUpdateResponse = _hasAllRequiredFields();
    $modal.find(".preview-button").toggleClass("disabled", !canUpdateResponse);
    $modal.find(".save-response-button").toggleClass("disabled", !canUpdateResponse);
    $modal
      .find(".lid-letter-communication-modal-projects .js-download-project-preview")
      .toggleClass("disabled", !canUpdateResponse);
  };

  var renderAndShow = async function (
    projectIds,
    { noticeData = {}, readOnly = false, action = null } = {},
  ) {
    $modal = $("#update-response-modal");
    initialFormData = {};

    await setProps(projectIds, noticeData, readOnly, action);
    setDefaults();
    render();
    initializeFields();
    setupForm(readOnly);
    renderReviewSummary();

    Analytics.sendScreenView("modal", formKey);
  };

  var setupForm = function (readOnly) {
    handleFormDisplayByAction(getCurrentData().action);
    checkEnableSendButton();

    if (readOnly) {
      Misc.toggleDisabledInputs($modal.find(".modal-body"), readOnly);
    }
  };

  var setProps = async function (projectIds, noticeData, readOnly, action) {
    const projectsData = await getProjectsData(projectIds);

    const isNew = !(noticeData?.send?.id || noticeData?.receive?.id);

    setProjectPortalReceiveNotice(noticeData, projectsData, isNew);
    const isPortalResponse =
      noticeData?.receive?.isPortalResponse ??
      (isNew && allProjectsNeedPortalResponse(projectsData));

    props = {
      ...noticeData,
      readOnly,
      isNew,
      isPortalResponse,
      projectsData,
      projectContactIdOptions: InspectionSummaryLetterModal.getProjectContactIdOptions(
        projectsData[0].contacts,
      ),
      bulkProjectContactTypeOptions: [
        {
          value: "operator-maintainer",
          name: "O&M Contact(s)",
        },
        {
          value: "owner",
          name: "Property Owner(s)/LRP",
        },
      ],
      openEnforcements: projectsData[0].openEnforcements ?? [],
      bmps: getProjectBmps(projectsData[0], noticeData, isNew),
      escalationActionOptions: BaseEnforcementAction().escalationActionOptions,
      followUpTypeOptions: InspectionSummaryLetterModal.getFollowUpTypeOptions(),
      response: getInitialResponse(projectsData),
    };

    if (!props.action) {
      props.action = getInitialAction(action, props, projectsData);
    }
  };

  var getInitialResponse = function (projectsData) {
    return projectsData.length === 1 ? null : false;
  };

  var getInitialAction = function (action, props, projectsData) {
    if (props.isNew) {
      if (action) {
        return action;
      } else if (props.isPortalResponse) {
        return getReceiveAction(props.response, props.isPortalResponse, props.bmps ?? []);
      } else {
        return projectsData.length === 1 ? null : "reminder";
      }
    } else {
      return getAction();
    }
  };

  var setProjectPortalReceiveNotice = function (noticeData, projectsData, isNew) {
    if (
      !noticeData?.["receive"] &&
      isNew &&
      projectsData.length === 1 &&
      projectsData[0].portalReceiveNotice
    ) {
      noticeData["receive"] = projectsData[0].portalReceiveNotice;
      delete noticeData["receive"].action;
    }
  };

  var allProjectsNeedPortalResponse = function (projectsData) {
    return projectsData.every((project) => project.portalReceiveNotice);
  };

  var getAction = function () {
    const sendAction = props.send?.action;
    const receiveAction = props.receive?.action;

    if (sendAction && receiveAction) {
      return `${receiveAction}-${sendAction}`;
    } else if (sendAction) {
      return sendAction;
    } else if (receiveAction) {
      return receiveAction;
    }

    return null;
  };

  var getProjectsData = async function (projectIds) {
    const projectsData = await ApiCalls.getConstructionProjectForLidAction(projectIds);

    for (const project of projectsData) {
      addFirstContactNames(project);
    }

    return projectsData;
  };

  var addFirstContactNames = function (project) {
    project.firstOmContactName = getFirstProjectContactNameByRole("operator-maintainer", project);
    project.firstOwnerContactName = getFirstProjectContactNameByRole("owner", project);
  };

  var getFirstProjectContactNameByRole = function (role, project) {
    return project.contacts?.find((contact) => contact.role === role)?.name;
  };

  var render = async function () {
    const html = nunjucks.render("modals/lid/letterResponseModal.njk", props);
    $modal.html(html);
    $modal.modal("show");
  };

  var initializeFields = function () {
    Form.initializeAndLoadListeners($modal, formKey);
    Form.manuallySetFormDataField(formKey, [], initialFormData);

    loadDomListeners();
    initializeDropzone();
  };

  var initializeDropzone = function () {
    const dropzone = Form.initializeDropzone(formKey, $modal, {
      existingFiles: $.extend(true, [], props.receive?.files),
      directUpload: true,
    });

    if (props.receive?.id) {
      dropzone.setDownloadHandler((filename) => {
        ApiCalls.downloadLidSelfInspectionFile(props.receive.id, "receive", filename);
      });
    }
  };

  var _getUpdateData = function (clearData = false) {
    let updateData = Form.getDataFromForm(formKey, clearData);
    updateData = _getLetterUpdateData(updateData);
    addProjectIds(updateData);
    return updateData;
  };

  var addProjectIds = function (updateData) {
    updateData.projectIds = props.projectsData.map(function (project) {
      return { id: project.id, isPortalResponse: !!project.portalReceiveNotice };
    });
  };

  var _getLetterUpdateData = function (updateData) {
    if (!updateData.action) {
      updateData.action = props?.action;
    }
    _updateSendReceive(updateData);

    if (updateData.receive) {
      if (props.isNew && !props.receive?.isPortalResponse) {
        updateData.receive.sentDate = DateTime.getNowIso();
      }

      combineBmpMaintenance(updateData);
    }

    _addActionFormData(updateData);

    return updateData;
  };

  var combineBmpMaintenance = function (updateData) {
    if (props.projectsData.length !== 1) {
      return;
    }

    const bmpMaintenanceUpdates = [];

    for (const bmp of props.bmps ?? []) {
      const bmpUpdate = updateData.receive.bmpMaintenance?.[bmp.id] ?? {};
      bmpMaintenanceUpdates.push({
        ...bmp,
        ...bmpUpdate,
      });
    }

    updateData.receive.bmpMaintenance = bmpMaintenanceUpdates;
  };

  var _updateSendReceive = function (updateData) {
    const actionTypes = getActionTypes(updateData.action);

    _setOrUnsetSendReceive(updateData, "send", actionTypes.send);
    _setOrUnsetSendReceive(updateData, "receive", actionTypes.receive);
  };

  var _setOrUnsetSendReceive = function (updateData, actionType, action) {
    if (action) {
      if (!updateData[actionType]) {
        updateData[actionType] = {};
      }

      updateData[actionType].action = action;

      if (props[actionType]?.id) {
        updateData[actionType].id = props[actionType].id;
      }
    } else {
      delete updateData[actionType];
    }
  };

  var _addActionFormData = function (updateData) {
    const actionData = {
      receive: {
        receive: {
          reviewResult: "approved",
        },
      },
      "receive-reminder": {
        receive: {
          action: "receive",
          reviewResult: "rejected",
        },
        send: {
          action: "reminder",
        },
      },
    }[updateData.action];

    if (actionData && props.isNew) {
      $.extend(true, updateData, actionData);
    }
  };

  var _save = async function () {
    try {
      await Form.getReadyToSavePromise(formKey);
      const updateData = _getUpdateData(true);
      await ApiCalls.saveLidSelfInspection(updateData);

      close();
      PostConstructionProjectGeoServerLayer.invalidateLayerData();
    } catch (e) {
      return UploadValidator.reportError(e);
    }
  };

  var close = function () {
    Form.clearForm(formKey);
    $modal.modal("hide");
    $modal.html("");
    Analytics.sendScreenView();
  };

  var _hasAllRequiredFields = function () {
    if (Form.isFormEmpty(formKey)) {
      return false;
    }

    const data = getCurrentData();
    const requiredFields = getActionRequiredFields(data.action);

    return requiredFields.every(function (requiredField) {
      const value = _getDataFromInputName(requiredField, data);
      return value !== undefined && value !== null && value !== "";
    });
  };

  var getActionRequiredFields = function (action) {
    const actionTypes = getActionTypes(action);
    const requiredFields = [];

    if (actionTypes.receive) {
      if (!props.isPortalResponse) {
        requiredFields.push("receive[receivedDate]");
      }

      props.bmps?.forEach((bmp) => {
        requiredFields.push(`receive[bmpMaintenance][${bmp.id}][maintained]`);
      });
    }
    if (actionTypes.send) {
      if (props.projectsData.length === 1) {
        requiredFields.push("send[projectContactId]");
      } else {
        requiredFields.push("send[bulkProjectContactType]");
      }

      requiredFields.push("send[followUpType]");
      requiredFields.push("send[responseDueDate]");
      requiredFields.push("send[name]");
      requiredFields.push("send[signature]");
    }
    if (props.isNew && !props.isPortalResponse) {
      requiredFields.push("response");
    }

    requiredFields.push("flagEnforcement");

    return requiredFields;
  };

  var _getDataFromInputName = function (inputName, data) {
    const pathParts = Form.getPathPartsFromName(inputName);
    return Form.getDataAtPath(data, pathParts);
  };

  var getReceiveAction = function (hasResponse, isPortalResponse, bmpMaintenance) {
    if (!hasResponse && !isPortalResponse) {
      return "reminder";
    }
    if (bmpMaintenance.every((bmp) => bmp.maintained)) {
      return "receive";
    }
    return "receive-reminder";
  };

  var _toggleAction = function () {
    const data = _getUpdateData();
    const bmpMaintenance = data.receive?.bmpMaintenance ?? [];

    props.action = getReceiveAction(data.response, props.isPortalResponse, bmpMaintenance);
    handleFormDisplayByAction(props.action);
    renderReviewSummary();
  };

  var handleFormDisplayByAction = function (action) {
    const actionTypes = getActionTypes(action);
    const $saveButton = $modal.find(".save-response-button");

    $(`[data-show-action]`).hide();
    $(`[data-show-action~="${action}"]`).show();

    if (action === "receive-reminder") {
      $saveButton.text("Reject & Generate");
    } else if (action === "receive") {
      $saveButton.text("Save & Approve");
    } else if (actionTypes.send) {
      $saveButton.text("Save & Generate");
    } else {
      $saveButton.text("Save & Close");
    }

    $modal.find(".associated-bmps table").toggleClass("bmp-maintenance", !!actionTypes.receive);
    $modal.find(".associated-bmps table .bmp-maintenance").toggle(!!actionTypes.receive);
  };

  var _onPreviewLetter = async function () {
    previewLetter(props?.projectsData?.[0].id);
  };

  var previewLetter = async function (projectId) {
    InspectionPreview.preview(function () {
      const updateData = _getUpdateData();
      updateData.projectIds.filter((project) => project.id === projectId);
      return updateData;
    }, ApiCalls.previewLidSelfInspectionPdf);
  };

  var getActionTypes = function (action) {
    const actionTypes = {
      reminder: { send: "reminder", receive: false },
      "receive-reminder": { send: "reminder", receive: "receive" },
      receive: { send: false, receive: "receive" },
      unresponsive: { send: false, receive: "unresponsive" },
      null: {},
    };

    const metadata = actionTypes[action];

    if (!metadata) {
      throw new Error(`Unknown action ${action}`);
    }

    return metadata;
  };

  var _onEditProject = async function (event) {
    $modal.modal("hide");

    const projectId = $(event.currentTarget).closest("tr").data("id");
    await ProjectInventoryModalController.invokeProjectInventoryModal(
      projectId,
      "project-contacts",
    );

    const $inventoryModal = InventoryModal.getModal();
    $inventoryModal.one("hidden.bs.modal", () => _onProjectInventoryClose(projectId));
  };

  var _onProjectInventoryClose = async function (projectId) {
    $modal.modal("show");

    const projectData = (await getProjectsData([projectId]))[0];

    for (const i in props.projectsData) {
      if (props.projectsData[i].id === projectData.id) {
        props.projectsData[i] = projectData;
        rerenderProjectContact(projectData);
        return;
      }
    }
  };

  var rerenderProjectContact = function (projectData) {
    const newRowHtml = nunjucks.render("modals/lid/letterCommunicationModalContactRow.njk", {
      project: projectData,
    });
    $getProjectContactRowById(projectData.id).html(newRowHtml);
    setupForm(false);
  };

  var _onPreviewProject = function (event) {
    const projectId = $(event.currentTarget).closest("tr").data("id");
    previewLetter(projectId);
  };

  var $getProjectContactRowById = function (id) {
    return $modal.find(`.lid-letter-communication-modal-projects tr[data-id="${id}"]`);
  };

  var getCurrentData = function () {
    return $.extend(true, {}, props, Form.getDataFromForm(formKey, false));
  };

  var getProjectBmps = function (project, noticeData, isNew) {
    const recordedMaintenance = isNew ? [] : (noticeData.receive?.bmpMaintenance ?? []);
    const bmps = isNew ? (project.bmps ?? []) : getSavedNoticeBmps(project, recordedMaintenance);

    for (const bmp of bmps) {
      if (isNew) {
        addPortalMaintenanceData(bmp, project);
      } else if (recordedMaintenance.length) {
        addRecordedResponse(bmp, noticeData);
      }

      addAssetDetailsHistory(bmp, project, noticeData);
      bmp.cardText = getCardTitle(bmp.bmpName, bmp.bmpTypeObj?.name);
    }

    return bmps;
  };

  // Only a card built from the notice's own maintenance carries what the responsible party
  // submitted. A roster stand-in submitted nothing, and previousMaintenance is truthy even when
  // both its fields are missing, so decorating one renders empty Response Notes and Photos
  // sections for a response that was never recorded.
  var addRecordedResponse = function (bmp, noticeData) {
    if (noticeData.receive?.isPortalResponse) {
      bmp.previousMaintenance = {
        notes: bmp.notes,
        photos: bmp.photos,
      };
    } else if (noticeData.receive) {
      bmp.responsePhotos = bmp.photos;
    }
  };

  // A saved notice is rendered from the maintenance it recorded. When it recorded none - an older
  // notice, or a response reviewed before any per-BMP maintenance was entered - the project's full
  // BMP roster in bmpHistory stands in. project.bmps cannot: it is the current notice's subset,
  // which is empty whenever that notice names no unmaintained BMPs, so a notice reopened after a
  // completed review rendered no cards at all. A project sent without bmpHistory falls back to
  // that subset.
  var getSavedNoticeBmps = function (project, recordedMaintenance) {
    if (recordedMaintenance.length) {
      return recordedMaintenance;
    }

    return project.bmpHistory ? Object.values(project.bmpHistory) : (project.bmps ?? []);
  };

  var addPortalMaintenanceData = function (bmp, project) {
    const portalMaintenance = project.portalReceiveNotice?.bmpMaintenance ?? [];
    bmp.previousMaintenance = portalMaintenance.find((element) => element.id === bmp.id);
  };

  // Cards built from a saved notice carry only what was entered on it, so the inspection result
  // and the earlier maintenance response are read off the project's full BMP history instead.
  // project.bmps can be a narrower subset (e.g. only a non-compliant notice's unmaintained BMPs),
  // which a BMP reopened from an older historical notice may no longer be part of.
  var addAssetDetailsHistory = function (bmp, project, noticeData) {
    const history = project.bmpHistory?.[bmp.id];

    bmp.lastResult = history?.lastResult;
    bmp.lastResultDate = history?.lastResultDate;
    bmp.lastMaintenanceResponse = getPrecedingMaintenanceResponse(history, noticeData);
  };

  // History is relative to the notice on screen, not to the project. Reading the project's newest
  // reviewed response made a reviewed notice its own history, which rendered the same notes and
  // photos twice in one card.
  //
  // The chain is built from BMP maintenance rows, so a notice that recorded none for this BMP is
  // missing from it even though it was reviewed, and a reminder reopened from history carries no
  // receive notice at all. Position alone cannot place either one, and treating them like a notice
  // awaiting review would surface a response received after them, so their own date places them
  // instead. Only a notice with no date at all - a new to-do with no response yet - falls through
  // to the newest response.
  var getPrecedingMaintenanceResponse = function (history, noticeData) {
    const responses = history?.maintenanceResponses ?? [];
    const ownIndex = responses.findIndex(
      (response) => response.noticeId === noticeData.receive?.id,
    );

    if (ownIndex !== -1) {
      return responses[ownIndex + 1];
    }

    const noticeDate = noticeData.receive?.receivedDate ?? noticeData.send?.sentDate;

    if (!noticeDate) {
      return responses[0];
    }

    return responses.find((response) => response.receivedDate < noticeDate);
  };

  var getCardTitle = function (bmpName, bmpType) {
    return `${bmpName} — ${bmpType}`;
  };

  var renderReviewSummary = function () {
    const data = _getUpdateData();
    const bmpMaintenance = data.receive?.bmpMaintenance ?? [];

    const nonCompliantAssetCount = bmpMaintenance.filter((bmp) => !bmp.maintained).length;
    const totalAssetCount = props.bmps?.length ?? 0;
    const reviewSummaryHtml = nunjucks.render("modals/lid/partials/reviewSummary.njk", {
      nonCompliantAssetCount,
      compliantAssetCount: totalAssetCount - nonCompliantAssetCount,
      totalAssetCount,
    });
    $modal.find(".js-review-summary").html(reviewSummaryHtml);
  };

  var setDefaults = function () {
    if (!props.send) {
      props.send = {};
    }
    if (!initialFormData.send) {
      initialFormData.send = {};
    }
    if (!("name" in props.send)) {
      props.send.name = Session.getUser()["full_name"];
      initialFormData.send.name = props.send.name;
    }
  };

  return {
    renderAndShow,
    close,
    render,
    addFirstContactNames,
    getCardTitle,
    _hasAllRequiredFields,
    _closeModalIfConfirmed,
    _save,
    _getUpdateData,
    _saveResponseIfConfirmed,
    _onProjectInventoryClose,
    _onEditProject,
  };
};

module.exports = LetterResponseModal();

const Analytics = require("../general/analytics");
const ApiCalls = require("../apiCalls");
const CommonModalFunctions = require("../modals/commonModalFunctions");
const DateTime = require("../dateTime");
const Form = require("../general/form");
const MessageModal = require("../modals/messageModal");
const Misc = require("../misc");
const InspectionPreview = require("../general/inspectionPreview");
const ProjectInventoryModalController = require("../construction/projectInventoryModalController");
const InventoryModal = require("../general/inventoryModal");
const Session = require("../login/session");
const InspectionSummaryLetterModal = require("./inspectionSummaryLetterModal");
const BaseEnforcementAction = require("../enforcement/baseEnforcementAction");
const PostConstructionProjectGeoServerLayer = require("../constructionG2/postConstructionProjectGeoServerLayer");
const UploadValidator = require("../general/uploadValidator");
